import { forwardRef } from 'react';
import type { BusinessIconImageProps } from '../businessTypes';

type SmsProps = Omit<BusinessIconImageProps, 'color' | 'strokeWidth'>;

const Sms = forwardRef<SVGSVGElement, SmsProps>(
  ({ size = 24, width, height, alt = '', style, ...props }, ref) => (
    <svg
      ref={ref}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? size}
      height={height ?? size}
      role={alt ? 'img' : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
      style={style}
      {...props}
    >
      <g transform="matrix(0.83240844 0 0 0.83240844 -2.15094340 -1.78190899)">
        <g>
          <path d="M26.222 5.56738H7.76746C6.23983 5.56738 5 6.74875 5 8.20418V22.2674C5 23.7228 6.24007 24.9042 7.76794 24.9042H13.8451L16.3451 27.2859C16.5108 27.4456 16.744 27.5451 17.0026 27.5459C17.2381 27.5459 17.4713 27.4606 17.6549 27.2859L20.1549 24.9042H26.2321C27.7599 24.9042 29 23.7228 29 22.2674V8.20418C28.9899 6.74875 27.745 5.56738 26.222 5.56738ZM11.9148 16.1147C11.1509 16.1147 10.5306 15.5242 10.5306 14.7963C10.5306 14.0686 11.1509 13.4779 11.9148 13.4779C12.6787 13.4779 13.2988 14.0685 13.2988 14.7963C13.2988 15.524 12.6788 16.1147 11.9148 16.1147ZM17.4509 16.1147C16.687 16.1147 16.067 15.5242 16.067 14.7963C16.067 14.0686 16.687 13.4779 17.4509 13.4779C18.2149 13.4779 18.8349 14.0685 18.8349 14.7963C18.8349 15.524 18.2149 16.1147 17.4509 16.1147ZM22.9921 16.1147C22.2281 16.1147 21.6081 15.5242 21.6081 14.7963C21.6081 14.0686 22.2281 13.4779 22.9921 13.4779C23.756 13.4779 24.376 14.0685 24.376 14.7963C24.376 15.524 23.751 16.1147 22.9921 16.1147Z" fill="#FFD452" />
        </g>
      </g>
    </svg>
  ),
);

Sms.displayName = 'Sms';

export default Sms;
